/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from "react";
import "./AdminDSR.css";
import { AiOutlineClose } from "react-icons/ai";

const MonthlyReportTab = ({
  // filters
  reportFilters,
  setReportFilters,
  reportProjects,
  reportEmployees,
  fetchReportEmployees,
  fetchReportProjects,
  fetchMonthlyReport,
  handleReportReset,

  // table data
  monthlyReportData,
  reportTotalTime,
  fetchTasksForAdmin,

  // task modal
  showTaskModal,
  setShowTaskModal,
  taskModalData,
  filteredTaskList,
  taskSearch,
  setTaskSearch,
  taskList,
  setFilteredTaskList,
}) => {
  return (
    <>
      <div className="filters-section-AdminDSR">
        <div className="filter-group-AdminDSR">
          <label>From Date</label>
          <input
            type="date"
            className="date-input-AdminDSR"
            value={reportFilters.fromDate}
            onChange={(e) =>
              setReportFilters({
                ...reportFilters,
                fromDate: e.target.value,
                toDate: "",
              })
            }
          />
        </div>

        <div className="filter-group-AdminDSR">
          <label>To Date</label>
          <input
            type="date"
            className="date-input-AdminDSR"
            value={reportFilters.toDate}
            disabled={!reportFilters.fromDate}
            min={reportFilters.fromDate}
            onChange={(e) =>
              setReportFilters({
                ...reportFilters,
                toDate: e.target.value,
              })
            }
          />
        </div>

        <div className="filter-group-AdminDSR">
          <label>Select Project</label>
          <select
            className="select-dropdown-AdminDSR"
            value={reportFilters.projectId}
            onChange={(e) => {
              const projectId = e.target.value;
              // FIX: Only update projectId, keep userId intact.
              // Refetch employees filtered by this project but preserve current userId selection.
              setReportFilters((prev) => ({ ...prev, projectId }));
              fetchReportEmployees(projectId);
            }}
          >
            <option value="">Select</option>
            {reportProjects.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </div>

        <div className="filter-group-AdminDSR">
          <label>Employee</label>
          <select
            className="select-dropdown-AdminDSR"
            value={reportFilters.userId}
            onChange={(e) => {
              const userId = e.target.value;
              // FIX: Only update userId, keep projectId intact.
              // Refetch projects filtered by this employee but preserve current projectId selection.
              setReportFilters((prev) => ({ ...prev, userId }));
              fetchReportProjects(userId);
            }}
          >
            <option value="">Select</option>
            {reportEmployees.map((emp) => (
              <option key={emp.id} value={emp.id}>{emp.name}</option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className="search-button-AdminDSR"
            onClick={fetchMonthlyReport}
          >
            Search
          </button>

          <button
            className="cancel-button-AdminDSR"
            onClick={handleReportReset}
          >
            Reset
          </button>
        </div>
      </div>

      <div className="table-in-all-emplyee-AdminDSR">
        <table className="table-main-AdminDSR">
          <thead className="thead-main-AdminDSR">
            <tr>
              <th>#</th>
              <th>Project Name</th>
              <th>Employee Name</th>
              <th>Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="tbody-main-AdminDSR">
            {monthlyReportData.length > 0 ? (
              monthlyReportData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.ProjectName}</td>
                  <td>{item.UserName}</td>
                  <td>{item.TotalTime}</td>
                  <td>
                    <button
                      className="view-button-AdminDSR"
                      onClick={() => fetchTasksForAdmin(item)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No record found</td>
              </tr>
            )}
          </tbody>
        </table>
        {monthlyReportData.length > 0 && (
          <div
            style={{
              textAlign: "center",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            Total Time: {reportTotalTime || "N/A"}
          </div>
        )}
      </div>

      {showTaskModal && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-task-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Task Details</h3>
              <button
                onClick={() => setShowTaskModal(false)}
                className="close-button-AdminDSR"
              >
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-task-AdminDSR">
              <div className="task-info-row-AdminDSR">
                <div className="task-info-field-AdminDSR">
                  <label>Project Name</label>
                  <input
                    type="text"
                    value={taskModalData?.projectName || ""}
                    readOnly
                  />
                </div>
                <div className="task-info-field-AdminDSR">
                  <label>Employee Name</label>
                  <input
                    type="text"
                    value={taskModalData?.employeeName || ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="task-info-row-AdminDSR">
                <div className="task-info-field-AdminDSR">
                  <label>From Date</label>
                  <input type="text" value={reportFilters.fromDate} readOnly />
                </div>
                <div className="task-info-field-AdminDSR">
                  <label>To Date</label>
                  <input type="text" value={reportFilters.toDate} readOnly />
                </div>
              </div>

              <div className="task-entries-AdminDSR">
                <label>
                  Show <select><option>10</option></select> entries
                </label>

                <div className="search-in-task-AdminDSR">
                  <label>Search:</label>
                  <input
                    type="text"
                    value={taskSearch}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTaskSearch(value);

                      const filtered = taskList.filter((task) =>
                        task.task.toLowerCase().includes(value.toLowerCase())
                      );

                      setFilteredTaskList(filtered);
                    }}
                  />
                </div>
              </div>

              <div className="table-in-all-emplyee-AdminDSR">
                <table className="table-main-AdminDSR">
                  <thead className="thead-main-AdminDSR">
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Task</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-main-AdminDSR">
                    {filteredTaskList.length > 0 ? (
                      filteredTaskList.map((task, idx) => (
                        <tr key={task.id}>
                          <td>{idx + 1}</td>
                          <td>{task.date}</td>
                          <td>{task.task}</td>
                          <td>{task.time}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No tasks found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {taskModalData?.totalTime && (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "16px",
                    marginTop: "15px",
                  }}
                >
                  Total Time: {(() => {
                    const [h, m] = taskModalData.totalTime.split(":");
                    return `${parseInt(h, 10)} h ${parseInt(m, 10)} m`;
                  })()}
                </div>
              )}

              <div className="pagination-AdminDSR">
                <button>Previous</button>
                <button>Next</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MonthlyReportTab;